module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_02.fb053dca.png";